export const SET_BOOKING_FIELDS = 'SET_BOOKING_FIELDS';
export const ADD_BOOKING_FIELD = 'ADD_BOOKING_FIELD';
export const DELETE_BOOKING_FIELD = 'DELETE_BOOKING_FIELD';
export const BOOKING_FIELD_REQUIRED_SET = 'BOOKING_FIELD_REQUIRED_SET';
export const BOOKING_FIELD_REPEATED_SET = 'BOOKING_FIELD_REPEATED_SET';
export const BOOKING_FIELD_LABEL_SET = 'BOOKING_FIELD_LABEL_SET';
export const SET_SETTINGS_LOADING = 'SET_SETTINGS_LOADING';
export const BOOKING_FIELD_OPTIONS_SET = 'BOOKING_FIELD_OPTIONS_SET';
export const ORDER_BOOKING_FIELDS = 'ORDER_BOOKING_FIELDS';
export const BOOKING_FIELD_ITEM_UP = 'BOOKING_FIELD_ITEM_UP';
export const BOOKING_FIELD_ITEM_DOWN = 'BOOKING_FIELD_ITEM_DOWN';
export const BOOKING_FIELD_ITEM_DND = 'BOOKING_FIELD_ITEM_DND';

export const CHECKBOX_TYPE = 'checkbox';
export const SINGLE_LINE_TYPE = 'input';
export const TEXT_TYPE = 'text';
export const RADIO_TYPE = 'dropdown';
export const DROPDOWN_TYPE = 'radio';

export function fieldTypeLabel(fieldType) {
  switch(fieldType) {
    case SINGLE_LINE_TYPE:
      return 'Single line text';
    case TEXT_TYPE:
      return 'Multiple line text';
    case CHECKBOX_TYPE:
      return 'Checkbox';
    case DROPDOWN_TYPE:
      return 'Dropdown';
    case RADIO_TYPE:
      return 'Radio button';
    default:
      return ''
  }
}

export function onOrderBookingFields(fields) {
  return {
    type: ORDER_BOOKING_FIELDS,
    fields,
  };
}

export function onBookingFieldsSet(fields) {
  return {
    type: SET_BOOKING_FIELDS,
    fields
  };
}


export function onCheckboxFieldAdd() {
  let fieldType = CHECKBOX_TYPE;
  return {
    type: ADD_BOOKING_FIELD,
    fieldType
  };
}

export function onInputFieldAdd() {
  let fieldType = SINGLE_LINE_TYPE;
  return {
    type: ADD_BOOKING_FIELD,
    fieldType
  };
}

export function onTextFieldAdd() {
  let fieldType = TEXT_TYPE;
  return {
    type: ADD_BOOKING_FIELD,
    fieldType
  };
}

export function onDropdownFieldAdd() {
  let fieldType = DROPDOWN_TYPE;
  return {
    type: ADD_BOOKING_FIELD,
    fieldType
  };
}

export function onRadioFieldAdd() {
  let fieldType = RADIO_TYPE;
  return {
    type: ADD_BOOKING_FIELD,
    fieldType
  };
}

export function onRepeatFieldAdd() {
  let fieldType = REPEAT_TYPE;
  return {
    type: ADD_BOOKING_FIELD,
    fieldType
  };
}


export function onFieldDelete(index) {
  return {
    type: DELETE_BOOKING_FIELD,
    index
  };
}

export function onFieldRequiredSet(index, required) {
  return {
    type: BOOKING_FIELD_REQUIRED_SET,
    index,
    required
  };
}

export function onFieldRepeatSet(index, repeated) {
  return {
    type: BOOKING_FIELD_REPEATED_SET,
    index,
    repeated
  };
}

export function onFieldLabelSet(index, label) {
  return {
    type: BOOKING_FIELD_LABEL_SET,
    index,
    label
  };
}

export function onFieldOptionsSet(index, options) {
  return {
    type: BOOKING_FIELD_OPTIONS_SET,
    index,
    options
  };
}

export function onItemMoveUp(index) {
  return {
    type: BOOKING_FIELD_ITEM_UP,
    index
  }
}

export function onItemMoveDown(index) {
  return {
    type: BOOKING_FIELD_ITEM_DOWN,
    index
  }
}

export function onItemDragDrop(fields) {
  return {
    type: BOOKING_FIELD_ITEM_DND,
    fields
  }
}

export function onBookingFieldsSubmit(fields) {

  var search_params =  JSON.stringify(fields);
  btaa.notify('Saving...');
  return dispatch => {
    dispatch({type: SET_SETTINGS_LOADING, value: true});
    $.ajax({
      method: 'PATCH',
      url: '/admin/shop/booking_fields',
      dataType: 'json',
      data: { shop: {
        booking_fields: search_params
      }}
    }).done(function (response) {
      dispatch({type: SET_SETTINGS_LOADING, value: false});
      btaa.notify(response.message);
    }).fail(function (jqXHR, textStatus) {
      dispatch({type: SET_SETTINGS_LOADING, value: false});
    });
  }
}
